import instance, { ADMIN_PREFIX } from 'services/api';

/**
 * Translations are served as JSON blobs sitting in S3 under
 * /aws-s3/<folderKey>/<locale>/<fileName>.json — the admin
 * Translations page edits them in-place.
 */

/**
 * GET /aws-s3/get-data/:folderKey/:locale/:fileName — single-file
 * fetch for a single-locale namespace. Returns the raw JSON body.
 */
export const fetchTranslationFile = async (
  folderKey: string,
  locale: string,
  fileName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const res = await instance.get(
    `${ADMIN_PREFIX}/aws-s3/get-data/${folderKey}/${locale}/${fileName}`
  );

  return res.data;
};

/**
 * GET /aws-s3/list-json/:folderKey/:locale — listing of every
 * namespace JSON for a locale. Each value is the raw JSON string
 * keyed by fileName.
 */
export const listTranslationFiles = async (
  folderKey: string,
  locale: string
): Promise<Record<string, string>> => {
  const res = await instance.get<Record<string, string>>(
    `${ADMIN_PREFIX}/aws-s3/list-json/${folderKey}/${locale}`
  );

  return res.data;
};

/**
 * POST /aws-s3/create — full-replace write for a translation
 * namespace. `data` is the multi-locale JSON the editor produced.
 */
export const uploadTranslationFile = (
  folderKey: string,
  fileName: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any
) =>
  instance.post(`${ADMIN_PREFIX}/aws-s3/create`, data, {
    params: { folderKey, fileName },
    headers: { 'Content-Type': 'application/json; charset=utf-8' }
  });
